import { render, staticRenderFns } from "./modalAddNewTenantDashboard.vue?vue&type=template&id=2e9ef14f&"
import script from "./modalAddNewTenantDashboard.vue?vue&type=script&lang=js&"
export * from "./modalAddNewTenantDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports